/*
 *   Copyright (c) 2020 BuserNet Consulting LLC
 *   All rights reserved.
 */

import _forEach from 'lodash/forEach';
import capacitorService from './capacitor.service';
import AppConst from '../constants/app.constant';
import httpService from './http.service';
import auditDataFactory from './auditData.service';
import { openReportModalHandle } from '../modal/report.modal';

let mouseTimer;

function mouseUp() {
  if (mouseTimer) {
    window.clearTimeout(mouseTimer); // cancel timer when mouse button is released
  }
}

function mouseDown() {
  mouseUp();
  // set timeout to fire in 2 seconds when the user presses mouse button down
  mouseTimer = window.setTimeout(openReportModalHandle, 2000);
}
const reportService = () => {
  const content = {};
  content.datamode = null;
  content.nodeWithEvent = null;
  content.bindReportMethod = (datamode) => {
    content.datamode = datamode;
    window.setTimeout(() => {
      content.nodeWithEvent = document.getElementById('viewtitle');
      if (!content.nodeWithEvent) {
        return;
      }
      if (capacitorService.isCapacitorMobileApp) {
        content.nodeWithEvent.addEventListener('touchstart', mouseDown);
        content.nodeWithEvent.addEventListener('touchend', mouseUp);
      } else {
        content.nodeWithEvent.addEventListener('mousedown', mouseDown);
        document.body.addEventListener('mouseup', mouseUp);
      }
    }, 1000);
  };
  content.unbindReportMethod = () => {
    content.datamode = null;
    if (!content.nodeWithEvent) {
      return;
    }
    if (capacitorService.isCapacitorMobileApp) {
      content.nodeWithEvent.removeEventListener('touchstart', mouseDown);
      content.nodeWithEvent.removeEventListener('touchend', mouseUp);
    } else {
      content.nodeWithEvent.removeEventListener('mousedown', mouseDown);
      content.nodeWithEvent.removeEventListener('mouseup', mouseUp);
    }
    content.nodeWithEvent = null;
  };
  content.sendDataToJsonBlob = async (jsondata) => httpService.http_post(
    AppConst.jsonBlobAPI,
    jsondata,
  ).then((data) => {
    let locationHeader = jsondata;
    if (data.headers.location || data.headers.Location) {
      const locationHeaderValue = data.headers.location || data.headers.Location;
      locationHeader = locationHeaderValue;
    }
    return locationHeader;
  }, () => jsondata);
  content.postJsonToBlob = async () => {
    const promises = [];
    const auditDataKeys = Object.keys(auditDataFactory);
    const results = [];
    if (auditDataKeys) {
      _forEach(auditDataKeys, (item) => {
        promises.push(content.sendDataToJsonBlob(auditDataFactory[item]));
      });
      const responseBlobsUrls = await Promise.all(promises);
      _forEach(auditDataKeys, (item, key) => {
        results.push({
          key: item,
          value: responseBlobsUrls[key],
        });
      });
      return content.sendDataToJsonBlob(results).then((response) => response);
    }
  };
  content.copyToClipboard = (obj) => {
    const str = JSON.stringify(obj);
    const el = document.createElement('textarea'); // Create a <textarea> element
    el.value = str; // Set its value to the string that you want copied
    el.setAttribute('readonly', ''); // Make it readonly to be tamper-proof
    el.style.position = 'absolute';
    el.style.left = '-9999px'; // Move outside the screen to make it invisible
    document.body.appendChild(el); // Append the <textarea> element to the HTML document
    // Check if there is any content selected previously
    const selected = document.getSelection().rangeCount > 0
      ? document.getSelection().getRangeAt(0) // Store selection if found
      : false; // Mark as false to know no selection existed before
    el.select(); // Select the <textarea> content
    document.execCommand(
      'copy',
    ); // Copy - only works as a result of a user action (e.g. click events)
    document.body.removeChild(el); // Remove the <textarea> element
    if (selected) { // If a selection existed before copying
      document.getSelection().removeAllRanges(); // Unselect everything on the HTML document
      document.getSelection().addRange(selected); // Restore the original selection
    }
  };
  return content;
};
export default reportService();
